import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoaderCard from "components/loaderCard/LoaderCard";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import useOutsideAlerter from "hooks/useOutsideAlerter/useOutsideAlerter";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import React, { useRef, useState } from "react";
import { IFacility } from "redux/reducers/models/facility";
import { IFacilityPortalExtended, useTeeOnPortalContext } from "../../TeeOnPortalContext";
import FacilitiesDropdown from "./FacilitiesDropdown";
import "./teeOnPortalFacilities.scss";
import TeeOnPortalFacility from "./TeeOnPortalFacility";

interface IProps {
  loadTeeTimes: (faciltities: Array<IFacilityPortalExtended>) => Promise<void>;
}

export default function TeeOnPortalFacilities(props: IProps) {
  const { loadTeeTimes } = props;
  const { teeOnPortalState, updateTeeOnPortal } = useTeeOnPortalContext();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const ref = useRef();
  const windowSize = useWindowSize();

  useOutsideAlerter(ref, () => {
    setDropdownOpen(false);
  });

  function handleFacilityAdd(updatedFacilities: Array<IFacilityPortalExtended>) {
    if (updatedFacilities) {
      updateTeeOnPortal({ selectedFacilities: updatedFacilities });
      void loadTeeTimes(updatedFacilities);
    }
  }

  return (
    <div className="tee-on-portal-facilities">
      {teeOnPortalState?.selectedFacilities && windowSize.width <= MOBILE_WIDTH ? (
        <div className="tee-on-portal-facilities-mobile">
          {teeOnPortalState?.selectedFacilities?.map((facility, index) => {
            return <TeeOnPortalFacility key={index} facility={facility} loadTeeTimes={loadTeeTimes} />;
          })}
        </div>
      ) : teeOnPortalState?.selectedFacilities ? (
        teeOnPortalState?.selectedFacilities?.map((facility, index) => {
          return <TeeOnPortalFacility key={index} facility={facility} loadTeeTimes={loadTeeTimes} />;
        })
      ) : (
        <LoaderCard image textRows={2} />
      )}
      {teeOnPortalState?.selectedFacilities && teeOnPortalState?.selectedFacilities?.length < 5 && (
        <div ref={ref} className="tee-on-portal-facilities-add-button" onClick={() => setDropdownOpen(true)}>
          <FontAwesomeIcon icon={["far", "plus"]} size="1x" className="tee-on-portal-facilities-add-button-icon" />

          <FacilitiesDropdown
            open={dropdownOpen}
            facilities={teeOnPortalState?.facilities}
            selectedFacilities={teeOnPortalState?.selectedFacilities}
            onFacilityAdd={facilities => handleFacilityAdd(facilities)}
            onClose={() => setDropdownOpen(false)}
            position="left"
          />
        </div>
      )}
    </div>
  );
}
